import { useSticky } from '@group-link-one/gl-components';
import { UTPageTitle } from '@group-link-one/gl-ui/utilities';
import clsx from 'clsx';
import { AnimatePresence } from 'framer-motion';
import S from '../Main.template.style';
import { type IMainContent } from '../MainContent/types/MainContent.types';

const ChildContent = ({
  id,
  topTitle,
  topAddon,
  children,
  childContTopAlign,
  justChildContent,
  isSticked = false,
}: IMainContent) => {
  const { isSticky, stickyRef } = useSticky<HTMLDivElement>({
    topOffset: 5,
  });

  return (
    <S.ChildCont>
      <AnimatePresence mode='wait' initial={false}>
        {!justChildContent && (
          <S.ChildContTop
            ref={stickyRef}
            className={clsx(
              isSticky && isSticked ? 'is-stuck' : '',
              isSticked ? 'has-sticked' : '',
            )}
            key={`childContTop ${id}`}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            childContTopAlign={childContTopAlign}
          >
            {topTitle && <UTPageTitle {...topTitle} />}
            {topAddon}
          </S.ChildContTop>
        )}
      </AnimatePresence>

      {children}
    </S.ChildCont>
  );
};

export { ChildContent };
